import useLabels from './useLabels';

const TextTranslatable = ({ textId }) => {
  const [text] = useLabels(textId);
  return text;
};

export default TextTranslatable;
